var _defs, _path, _polygon, _path2, _path3, _rect, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCoraLogoWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 450.91 79.95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #FFFFFF;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M296.94,0c-7.01,0-12.43,5.55-12.43,12.71s5.41,12.71,12.43,12.71,12.43-5.55,12.43-12.71-5.41-12.71-12.43-12.71Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "448.4 2.37 446.48 2.37 444.94 2.37 444.94 77.58 446.48 77.58 448.4 77.58 450.91 77.58 450.91 2.37 448.4 2.37"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M400.8,0c-22.06,0-39.08,17.47-39.08,39.97s17.03,39.98,39.08,39.98,39.09-17.47,39.09-39.98S422.86,0,400.8,0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M166.9,0c-22.06,0-39.08,17.47-39.08,39.97s17.03,39.98,39.08,39.98,39.09-17.47,39.09-39.98S188.96,0,166.9,0Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 273.5,
    y: 2.37,
    width: 5.97,
    height: 75.21
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M69.71,60.94l-2.15-1.71-.31-.25s0,0,0,0l-.95-.76c-2.99,4.56-6.98,8.33-11.54,10.93-4.82,2.74-10.12,4.13-15.73,4.13-8.91,0-17.12-3.38-23.11-9.53-6.02-6.17-9.33-14.61-9.33-23.79s3.31-17.62,9.33-23.78c5.99-6.14,14.2-9.53,23.11-9.53,5.34,0,10.4,1.26,15.05,3.73,4.43,2.36,8.32,5.81,11.25,9.97l5.3-4.08C63.52,6.51,52.11,0,39.08,0,17.03,0,0,17.47,0,39.97s17.03,39.98,39.08,39.98c13.62,0,25.21-7.13,32.34-17.6l-1.73-1.39v-.02Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoraLogoWhite);
export default __webpack_public_path__ + "static/media/cora_logo_white.306258454f5b53e25d0577c3093e2687.svg";
export { ForwardRef as ReactComponent };